import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import React, { useEffect, useState } from 'react'
import {usePut,useCurrent} from '../../hooks/'
import { MwButton, MwSpinnerButton } from '../../components/ui'
import { useDispatch } from 'react-redux'
import {updateSettings} from '../../store/settingSlice'
import SettingListItem from '../../components/settings/SettingListItem'
import { useTranslation } from 'react-i18next'

const CENTRAL_SETTINGS_SCOPE = 'global';

const InvoiceSettings = ({refreshTenant,filterDefineSetting}) => {
    const {t} = useTranslation('global');
    const dispatch = useDispatch();
    const {currentCompanyId,currentTenantId,currentLangId,currentSettings} = useCurrent();
    const SETTING_INVOICE = currentSettings?.invoiceSettings;
    
    // Default invoice settings based on sales-26 implementation
    const defaultInvoiceSettings = {
        SHOW_ADDRESS_ON_PRINT: 'true',
        SHOW_PHONE_ON_PRINT: 'false',
        SHOW_QR_KSA_ON_PRINT: 'true',
        SHOW_VAT_ON_PRINT: 'true',
        SHOW_LOGO_ON_PRINT: 'false',
        SHOW_TERMS_ON_PRINT: 'true',
        SHOW_EMAIL_ON_PRINT: 'true',
        TYPE_INV_PRINT: 'sm',
        INV_TERMS_PRINT: '[{"text":"terms" , "lang" : "en"},{"text":"يحق للعميل رفع طلب استبدال او استرجااع للمنتج في حالة وجود اي مشكله في المنتج وتعذر فريق الصيانه صيانتها" , "lang" : "ar"}]',
        PRODUCT_LEVEL: 'TenantAndCompany',
        PRICE_INCLUDE_VAT: 'false',
        INV_NO_FORMAT: 'UserAndNumber',
        INV_NO_SEPERATE: '-',
        INV_PREFIX: 'inv-',
        INV_VAT_PERCENT: '15',
        INV_TO_FIXED_NUMBER: '1',
        INV_ITEMS_ROW_NUMBER: '1',
        INV_NO_START: '100',
        INV_CURRENCY: '[ {"code" : "SAR" , "lang" : "en" } , {"code" : "ر.س" , "lang" : "ar" }]'
    };
    
    const [invSetting,setInvSetting] = useState(SETTING_INVOICE || defaultInvoiceSettings)
    const {data,loading,putData} = usePut()

    const invSettingArray = Object.entries(invSetting || {});
    const invSettingList =  invSettingArray.map(([settingName,settingValue]) =>(
        <SettingListItem
            key={settingName}
            settingName = {settingName}
            settingValue = {settingValue}
            filterDefineSetting = {filterDefineSetting}
            setGeneralSetting = {setInvSetting}
            generalSetting = {invSetting}
            currentLangId = {currentLangId}
            prefixLang = 'invoice'
            />
    ));

    useEffect(()=>{
        if(data){
            refreshTenant();
        }
    },[data]);

    // Update local state when Redux state changes
    useEffect(() => {
        if (SETTING_INVOICE) {
            setInvSetting(SETTING_INVOICE);
        }
    }, [SETTING_INVOICE]);

    const saveHandler = async() => {
        try {
            const _data = {
                tenantId: currentTenantId,
                companyId: currentCompanyId,
                scope: CENTRAL_SETTINGS_SCOPE,
                data: {
                    invoiceSettings: invSetting,
                    generalSettings: currentSettings?.generalSettings || {},
                    quoteSettings: currentSettings?.quoteSettings || {}
                }
            };
            console.log(_data);
            await putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`,_data)
            dispatch(updateSettings({
                typeSetting : 'invoice',
                value : invSetting
            }));
        } catch (err) {
            console.error('Failed to save invoice settings:', err);
        }
    }

    if (invSettingArray.length === 0) {
        return <SettingsEmptyState title={t('setting.invoiceSettings')} />;
    }

    return (
        <div className="settings-editable-page">
            <div className='flex justify-between items-center mb-6'>
                <h1 className="text-2xl font-bold text-gray-800">{t("setting.invoiceSettings")}</h1>
                {loading ? <MwSpinnerButton /> : <MwButton
                    inGroup={true}
                    size='sm'
                    onClick={saveHandler}
                    type='saveBtn'
                >
                    {t("setting.Save_changes")}
                </MwButton>}
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                {invSettingList}
            </div>
        </div>
    )
}

export default InvoiceSettings
